import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { EbookDownload } from "./EbookDownload";

export const HeroSection = () => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://res.cloudinary.com/jerrick/image/upload/d_642250b563292b35f27461a7.png,f_jpg,fl_progressive,q_auto,w_1024/65a7d88440d36d001dec9f83.webp')`
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-spirit-50 to-mystic-50 opacity-50" />
      <div className="relative z-10 container mx-auto px-4 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="space-y-6"
        >
          <span className="inline-block px-3 py-1 text-sm font-medium bg-spirit-100 text-spirit-700 rounded-full animate-float">
            Discover Your Divine Connection
          </span>
          <h1 className="text-5xl md:text-7xl font-serif font-medium text-gray-900 tracking-tight">
            Twin Flames
          </h1>
          <p className="max-w-2xl mx-auto text-xl text-gray-600 leading-relaxed">
            Explore the profound journey of twin flame connections, where two souls mirror each other in perfect harmony and divine purpose.
          </p>
          <div className="mt-8 max-w-xl mx-auto">
            <EbookDownload source="hero_section" />
          </div>
        </motion.div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white to-transparent" />
    </section>
  );
};